import { Storage } from 'react-jhipster';

import { setLocale } from 'app/shared/reducers/locale';
import { ACTION_TYPES } from './store/actions';
import { userApi } from '../api';

export const displayAuthError = message => ({ type: ACTION_TYPES.ERROR_MESSAGE, message });

export const getUser: () => void = () => async (dispatch, getState) => {
  await dispatch({
    type: ACTION_TYPES.GET_USER,
    payload: userApi.getAccount(),
  });

  const { account } = getState().authentication;
  if (account && account.langKey) {
    const langKey = Storage.session.get('locale', account.langKey);
    await dispatch(setLocale(langKey));
  }
};

export const logout = () => async dispatch => {
  sessionStorage.removeItem('connectedSellingPoint');

  await dispatch({
    type: ACTION_TYPES.LOGOUT,
    payload: userApi.getLogout(),
  });
  // fetch new csrf token
  // dispatch(getUser());
};

export const clearAuthentication = messageKey => (dispatch, getState) => {
  dispatch(displayAuthError(messageKey));
  dispatch({
    type: ACTION_TYPES.CLEAR_AUTH,
  });
  // routerHistory.push('/');
};

export const findSellingPoint = () => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.FIND_SELLING_POINT,
    payload: userApi.findSellingPoint(),
  });
};
